import { render, staticRenderFns } from "./EditMarquee.vue?vue&type=template&id=8f30d8f2&"
import script from "./EditMarquee.vue?vue&type=script&lang=js&"
export * from "./EditMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports